<!-- src/views/HomePage.vue -->
<template>
    <div class="home-page">
      <h1>Welcome to Taxscan AI</h1>
      <p>Choose an option to proceed:</p>
      <div class="button-group">
        <button @click="handleAskAI" class="ask-ai-button">Ask AI</button>
        <button @click="openJudgements" class="judgements-button">Judgements</button>
      </div>
    </div>
    <footer class="footer">
      <p>© {{ new Date().getFullYear() }} Taxscan Edutech Private Limited. All rights reserved.</p>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'HomePage',
    methods: {
      handleAskAI() {
        // Check if token is valid, if not valid => go to /login
        const token = localStorage.getItem('auth_token');
        if (!token) {
          this.$router.push('/login');
        } else {
          this.$router.push('/ask-ai');
        }
      },
      openJudgements() {
        alert('🚧 Judgements Section Coming Soon!');
      },
    },
  };
  </script>
  
  <style scoped>
  .home-page {
  /* Fills entire screen if you want full page for home alone */
  width: 100%;
  min-height: 100vh;    /* ensures full viewport height */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* centers content horizontally & vertically */
  background: #f9f9f9;  /* or any background color/image */
  }
  .button-group {
    display: flex;
    flex-direction: row;
    gap: 15px;
    margin-top: 20px;
    justify-content: center;
  }
  .ask-ai-button,
  .judgements-button {
    width: 200px;
    padding: 12px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    text-align: center;
  }
  .ask-ai-button {
    background-color: #007bff;
    color: white;
  }
  .ask-ai-button:hover {
    background-color: #0056b3;
  }
  .judgements-button {
    background-color: #ff9800;
    color: white;
  }
  .judgements-button:hover {
    background-color: #e68900;
  }
  </style>
  